import React, { useState } from 'react';
import { ButtonTertiary, ButtonPrimary } from '@spotify-internal/encore-web';

import { useTranslation } from 'providers/translations/TranslationProvider';

import { ReasonKey } from '../../hooks/useSubmitReason';
import ReasonSelector from '../ReasonSelector';

import { StyledDialogAlert, StyledActions, StyledDialogHeader } from './styles';

interface ReasonPollProps {
  onSubmit: (reason: ReasonKey) => void;
  onCancelClick: () => void;
}

const ReasonPoll = ({ onSubmit, onCancelClick }: ReasonPollProps) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState<ReasonKey>();

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        if (reason) onSubmit(reason);
      }}
    >
      <StyledDialogAlert
        id="reason-poll"
        data-testid="reason-poll"
        colorSet="announcement"
        dialogTitle={<StyledDialogHeader>{t('feedback_widget_was_this_helpful')}</StyledDialogHeader>}
        body={<ReasonSelector selected={reason} onSelect={setReason} />}
        footer={
          <StyledActions>
            <ButtonTertiary type="button" buttonSize="sm" condensed onClick={onCancelClick}>
              {/* {t('feedback_cancel_reason')}*/}
              Cancel
            </ButtonTertiary>
            <ButtonPrimary type="submit" buttonSize="sm">
              {/* {t('feedback_submit_reason')}*/}
              Submit
            </ButtonPrimary>
          </StyledActions>
        }
      />
    </form>
  );
};

export default ReasonPoll;
